
import * as React from 'react';

import { BlockView } from 'common/views/block/BlockView.view';
import HeadingView from 'common/views/heading/Heading.view';
import TypographyView from 'common/views/typographyView/Typography.view';
import Label from 'core/components/label/Label';
import { IPanelProps, Panel } from 'core/decorators/Panel';
import TextPanelConfig from './TextConfig';

/**
 * @overview: Simple panel to display configurable text. Similar to
 * the common-text portlet in wicket14.
 *
 * @author: jesposito
 */

@Panel({id: "text", configClass: TextPanelConfig})
export class TextPanel extends React.PureComponent<IPanelProps<TextPanelConfig>> {

	public render() {
		const { body, labelKey, useBlockView, view } = this.props.config;

		const label = (
			<Label
				k={labelKey || "panel." + this.props.instance}
				v={body || "No Default Text"}
				allowMarkdown={true}
				allowHtml={true}
			/>
		);

		if ((typeof view === "undefined" && useBlockView) || "block" === view) {
			return (
				<BlockView viewKey="block">
					{label}
				</BlockView>
			);
		}

		if ("heading" === view) {
			return (
				<HeadingView viewKey="wrapper">
					{label}
				</HeadingView>
			);
		}

		if ("typography" === view) {
			return (
				<TypographyView viewKey="wrapper">
					{label}
				</TypographyView>
			);
		}

		return label;
	}
}



// WEBPACK FOOTER //
// ./src/panels/text/TextPanel.panel.tsx